module.exports = __webpack_public_path__ + "img/books.301e70f1.png";